/* eslint-disable */

import { isEditModeFooter } from 'js/helpers.js';

(function() {
    "use strict";

    var NS = "cmp";
    var IS = "multimedia-grid";

    var selectors = {
        self: "[data-" +  NS + '-is="' + IS + '"]'
    };

    /**
     * MultimediaGrid
     *
     * @class MultimediaGrid
     * @classdesc An interactive MultimediaGrid component for navigating a list of generic items
     * @param {MultimediaGridConfig} config The MultimediaGrid configuration
     */
    function MultimediaGridEditor(config) {
        var that = this;

        if (config && config.element) {
            init(config);
        }

        /**
         * Initializes the Multimedia Grid
         *
         * @private
         * @param {MultimediaGridConfig} config The MultimediaGrid configuration
         */
        function init(config) {

            // prevents multiple initialization
            config.element.removeAttribute("data-" + NS + "-is");

            cacheElements(config.element);

            that._active = 0;

            if (that._elements.item) {
                refreshActive();
            }

            if (window.Granite && window.Granite.author && window.Granite.author.MessageChannel) {
                /*
                 * Editor message handling:
                 * - subscribe to "cmp.panelcontainer" message requests sent by the editor frame
                 * - check that the message data panel container type is correct and that the id (path) matches this specific MultimediaGrid component
                 * - if so, route the "navigate" operation to enact a navigation of the MultimediaGrid based on index data
                 */
                new window.Granite.author.MessageChannel("cqauthor", window).subscribeRequestMessage("cmp.panelcontainer", function(message) {
                    if (message.data && message.data.type === "cmp-multimedia-grid" && message.data.id === that._elements.self.dataset["cmpPanelcontainerId"]) {
                        if (message.data.operation === "navigate") {
                            navigate(message.data.index);
                        }
                    }
                });
            }
        }

        /**
         * Caches the MultimediaGrid elements as defined via the {@code data-multimedia-grid-hook="ELEMENT_NAME"} markup API
         *
         * @private
         * @param {HTMLElement} wrapper The MultimediaGrid wrapper element
         */
        function cacheElements(wrapper) {
            that._elements = {};
            that._elements.self = wrapper;
            var hooks = that._elements.self.querySelectorAll("[data-" + NS + "-hook-" + IS + "]");

            for (var i = 0; i < hooks.length; i++) {
                var hook = hooks[i];
                var key = hook.dataset["cmpHookMultimediaGrid"];
                if (that._elements[key]) {
                    if (!Array.isArray(that._elements[key])) {
                        var tmp = that._elements[key];
                        that._elements[key] = [tmp];
                    }
                    that._elements[key].push(hook);
                } else {
                    that._elements[key] = hook;
                }
            }
        }

        /**
         * Refreshes the item markup based on the current {@code MultimediaGrid#_active} index
         *
         * @private
         */
        function refreshActive() {
            var items = that._elements["item"];

            if (items) {
                if (Array.isArray(items)) {
                    for (var i = 0; i < items.length; i++) {
                        if (i === parseInt(that._active)) {
                            items[i].classList.add("cmp-multimedia-grid__thumbnail--active");
                            items[i].removeAttribute("aria-hidden");
                        } else {
                            items[i].classList.remove("cmp-multimedia-grid__thumbnail--active");
                            items[i].setAttribute("aria-hidden", true);
                        }
                    }
                } else {
                    // only one item
                    items.classList.add("cmp-multimedia-grid__thumbnail--active");
                }
            }
        }

        /**
         * Navigates to the item at the provided index
         *
         * @private
         * @param {Number} index The index of the item to navigate to
         */
        function navigate(index) {
            if (index < 0 || index > (that._elements["item"].length - 1)) {
                return;
            }

            that._active = index;
            refreshActive();
        }
    }

    /**
     * Reads options data from the MultimediaGrid wrapper element, defined via {@code data-cmp-*} data attributes
     *
     * @private
     * @param {HTMLElement} element The MultimediaGrid element to read options data from
     * @returns {Object} The options read from the component data attributes
     */
    function readData(element) {
        var data = element.dataset;
        var options = [];
        var capitalized = IS;
        capitalized = capitalized.charAt(0).toUpperCase() + capitalized.slice(1);
        var reserved = ["is", "hook" + capitalized];

        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var value = data[key];

                if (key.indexOf(NS) === 0) {
                    key = key.slice(NS.length);
                    key = key.charAt(0).toLowerCase() + key.substring(1);

                    if (reserved.indexOf(key) === -1) {
                        options[key] = value;
                    }
                }
            }
        }

        return options;
    }

    /**
     * Document ready handler and DOM mutation observers. Initializes MultimediaGrid components as necessary.
     *
     * @private
     */
    function onDocumentReady() {
        var elements = document.querySelectorAll(selectors.self);
        for (var i = 0; i < elements.length; i++) {
            new MultimediaGridEditor({ element: elements[i], options: readData(elements[i]) });
        }

        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        var body             = document.querySelector("body");
        var observer         = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // needed for IE
                var nodesArray = [].slice.call(mutation.addedNodes);
                if (nodesArray.length > 0) {
                    nodesArray.forEach(function(addedNode) {
                        if (addedNode.querySelectorAll) {
                            var elementsArray = [].slice.call(addedNode.querySelectorAll(selectors.self));
                            elementsArray.forEach(function(element) {
                                new MultimediaGridEditor({ element: element, options: readData(element) });
                            });
                        }
                    });
                }
            });
        });

        observer.observe(body, {
            subtree: true,
            childList: true,
            characterData: true
        });
    }

    if (isEditModeFooter()) {
        if (document.readyState !== "loading") {
            onDocumentReady();
        } else {
            document.addEventListener("DOMContentLoaded", onDocumentReady);
        }
    }

}());
/* eslint-disable */
